import { RaffleParticipant, RaffleResultWinner } from "@/apps/raffle/types";
import { buildSectors } from "@/apps/raffle/components/RaffleWheel/wheelMath";

const FULL_SPINS = 6;

export const getWinnerKey = (winner: RaffleResultWinner) =>
  winner.yandex_id ?? winner.name;

const findWinnerParticipantIndex = (
  participants: RaffleParticipant[],
  winner: RaffleResultWinner
) => {
  const byName = participants.findIndex(
    (participant) => participant.name === winner.name
  );

  if (byName >= 0) return byName;

  return participants.findIndex(
    (participant) => participant.is_me && winner.is_me
  );
};

export const getWinnerSpinTarget = (
  participants: RaffleParticipant[],
  winner: RaffleResultWinner,
  currentRotation: number
) => {
  const sectors = buildSectors(participants);
  const participantIndex = findWinnerParticipantIndex(participants, winner);
  const targetIndex = Math.max(participantIndex, 0);
  const sector = sectors[targetIndex];

  if (!sector) return null;

  const targetRotation = (360 - sector.midAngle) % 360;
  const currentRotationMod = ((currentRotation % 360) + 360) % 360;
  const alignmentDelta = (targetRotation - currentRotationMod + 360) % 360;

  return {
    targetIndex,
    rotation: currentRotation + FULL_SPINS * 360 + alignmentDelta,
  };
};
